
document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("enquiryPopup");
    const closeBtn = document.querySelector(".popup-close");
    const overlay = document.querySelector(".popup-overlay");

    // View Details button
    document.querySelectorAll(".view-details-btn").forEach(function(btn) {

        btn.addEventListener("click", function(e) {
            e.preventDefault();

            if (popup) {
                popup.classList.add("active");
                document.body.style.overflow = "hidden";
            }
        });

    });

    function closePopup() {
        if (popup) {
            popup.classList.remove("active");
            document.body.style.overflow = "";
        }
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", closePopup);
    }

    if (overlay) {
        overlay.addEventListener("click", closePopup);
    }

    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
            closePopup();
        }
    });

});

// Success popup after contact form submit
window.addEventListener("load", function () {

    const params = new URLSearchParams(window.location.search);

    if (params.get("contact_posted") === "true") {

        const successPopup = document.getElementById("successPopup");

        if (successPopup) {

            successPopup.classList.add("active");

            setTimeout(function () {
                successPopup.classList.remove("active");

                // URL clean kar do
                history.replaceState({}, "", window.location.pathname);

            }, 2500);

        }

    }

});
